import PubSub from "underpub-js";

var FloorplanHeader = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-FloorplanHeader',
	};

	$.extend(true, this.options, options);

};

FloorplanHeader.prototype.init = function() {

	var self = this;

};

export default FloorplanHeader;
